export const adminKeys = {
  adminInfo: ['admin', 'admin-info'] as const,
  activities: ['admin', 'activities'] as const,
  activityDetail: (id: string) => ['admin', 'activities', id] as const,
  careers: ['admin', 'careers'] as const,
  careerDetail: (id: string) => ['admin', 'careers', id] as const,
};
